import { render } from "./EspaceAdminClientView.vue?vue&type=template&id=0fb30248&scoped=true"
import script from "./EspaceAdminClientView.vue?vue&type=script&lang=js"
export * from "./EspaceAdminClientView.vue?vue&type=script&lang=js"

import "./EspaceAdminClientView.vue?vue&type=style&index=0&id=0fb30248&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb30248"]])

export default __exports__